import { render, staticRenderFns } from "./agentMemberReportList.vue?vue&type=template&id=20a500c7&scoped=true&lang=html&"
import script from "./agentMemberReportList.vue?vue&type=script&lang=js&"
export * from "./agentMemberReportList.vue?vue&type=script&lang=js&"
import style0 from "./agentMemberReportList.vue?vue&type=style&index=0&id=20a500c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a500c7",
  null
  
)

export default component.exports